var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#7069FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07968 5.38049L4 8.46016V10L5.53984 9.99999L8.61951 6.92032M7.07968 5.38049L8.18398 4.27617L8.18465 4.27552C8.33666 4.1235 8.4128 4.04736 8.50057 4.01884C8.57789 3.99372 8.66118 3.99372 8.7385 4.01884C8.82621 4.04734 8.90226 4.12339 9.05406 4.27519L9.72381 4.94494C9.87626 5.09739 9.95252 5.17366 9.98108 5.26155C10.0062 5.33887 10.0062 5.42215 9.98107 5.49947C9.95253 5.5873 9.87639 5.66345 9.72416 5.81568L9.72382 5.81601L8.61951 6.92032M7.07968 5.38049L8.61951 6.92032",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPencil);
export default __webpack_public_path__ + "static/media/avatarPencil.a82fbb2b2c0c3540b451a028a9feb04f.svg";
export { ForwardRef as ReactComponent };